(ns hai.admin-ui.profile.setting-row
  "One switch per row, for the settings sections of the profile page."
  (:require
   [hai.ui.components :as c]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(o/defstyled setting-list :div
  :flex :flex-col
  {:gap "10px"})

(o/defstyled setting-row :div
  :flex :flex-col
  {:gap "6px"
   :padding "14px 16px"
   :border "1px solid var(--colour-rock)"
   :border-radius "10px"}
  ;; The switch sits on the title's line rather than centred against the whole
  ;; row, so it stays put as descriptions wrap to two lines.
  [:.setting-head
   :flex :items-center
   {:gap "8px"}]
  [:.setting-name
   {:font-size "15px" :font-weight "700"
    :color t/--text-secondary}]
  [:.setting-switch {:margin-left "auto"}]
  [:.setting-description
   {:font-size "14px"
    :color t/--colour-dim
    :max-width "60ch"}])

(defn setting-row-view
  [{:keys [label description checked? on-change]}]
  [setting-row
   [:div.setting-head
    [:span.setting-name label]
    [:span.setting-switch
     [c/Switch {:checked checked?
                :aria-label label
                :on-checked-change on-change}]]]
   [:span.setting-description description]])
